// @mui
import { alpha, keyframes, useTheme } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
//
import AuthStatisticsContent from './auth-statistics-content';

// ----------------------------------------------------------------------

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: .35;
  }
  50% {
    transform: scale(1.2);
    opacity: .15;
  }
  100% {
    transform: scale(1);
    opacity: .35;
  }
`;

const move = keyframes`
  0% {
    transform: translateX(-10%) translateY(0%);
  }
  50% {
    transform: translateX(10%) translateY(-5%);
  }
  100% {
    transform: translateX(-10%) translateY(0%);
  }
`;

const pulseGlow = keyframes`
  0% { opacity: 0.5; transform: scale(1); }
  50% { opacity: 0.75; transform: scale(2.5); }
  100% { opacity: 0.5; transform: scale(1); }
`;

// ----------------------------------------------------------------------

export default function AuthStatisticsLayout() {
  const theme = useTheme();

  const mdUp = useResponsive('up', 'md');

  return (
    <Stack
      flexGrow={1}
      sx={{
        position: 'relative',
        // overflow: 'hidden',
        p: 6,
      }}
    >
      {/* Animated Glow Background */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          // overflow: 'hidden',
        }}
      >
        {/* Main Glow */}
        <Box
          sx={{
            width: 500,
            height: 500,
            borderRadius: '50%',
            background: alpha(theme.palette.info.dark, 0.35),
            filter: 'blur(120px)',
            position: 'absolute',
            top: -120,
            right: -120,
            animation: `${move} 7s ease-in-out infinite`,
          }}
        />

        <Box
          sx={{
            width: 400,
            height: 400,
            borderRadius: '50%',
            background: alpha(theme.palette.primary.dark, 0.35),
            filter: 'blur(120px)',
            position: 'absolute',
            bottom: -100,
            left: -100,
            animation: `${pulseGlow} 8s ease-in-out infinite`,
          }}
        />

        {/* Floating dots */}
        {mdUp
          ? [...Array(12)].map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 15,
                  height: 15,
                  borderRadius: '50%',
                  backgroundColor: alpha(theme.palette.primary.light, 0.8),
                  position: 'absolute',
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  filter: 'blur(15px)',
                  animation: `${pulse} ${2 + (index % 4)}s infinite ease-in-out`,
                  boxShadow: `0 0 18px ${theme.palette.primary.main}`,
                }}
              />
            ))
          : null}
      </Box>

      {/* Content */}
      <AuthStatisticsContent />
    </Stack>
  );
}
